import { useCallback } from 'react';

import { useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import { PatientMedicalInformationRemoveReasonFieldFormValue } from './PatientMedicalInformationRemoveReasonField.types';

export const useTriggerLabelExtractor = (): ((
   reason: PatientMedicalInformationRemoveReasonFieldFormValue
) => string) => {
   const translate = useTranslate();

   return useCallback(
      (reason: PatientMedicalInformationRemoveReasonFieldFormValue) => {
         return translate(translationKeys.reasonMap[reason]);
      },
      [translate]
   );
};
